import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="relative overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={article.title}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700">
              {article.readTime}
            </span>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views.toLocaleString()} 次阅读
          </span>
        </div>
        <Link to={`/article/${article.slug}`} className="block cursor-pointer">
          <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          {article.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}